import TokenService from './tokenService';

let redirecting = false;

function requestHadAuthHeader(config) {
  if (!config?.headers) return false;
  const h = config.headers;
  return Boolean(h.Authorization || h.authorization);
}

/**
 * Clears session and sends the user to the login page (full navigation).
 * Used when the access token is missing, expired client-side, or rejected by the API.
 */
export function redirectToLogin() {
  if (redirecting) return;
  if (typeof window === 'undefined') return;
  const path = window.location.pathname || '';
  if (path === '/login' || path.startsWith('/login/')) return;

  redirecting = true;
  TokenService.clearToken();
  window.location.replace('/login');
}

/**
 * Call from axios interceptors when the server rejects the session.
 */
export function redirectToLoginIfUnauthorized(error) {
  const status = error?.response?.status;
  if (status === 401) {
    redirectToLogin();
    return;
  }
  if (status === 403 && requestHadAuthHeader(error?.config)) {
    redirectToLogin();
  }
}
